import {Observable, ReplaySubject} from 'rxjs';
import {Response} from '@angular/http';
import {Model} from './model.class';
import {Service} from './service.class';
import ProjectionInformation = Model.ProjectionInformation;

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class ModelService<T extends Model<T>> {

    private _service: Service;

    private _changesSubject$ = new ReplaySubject<boolean>(1);
    changes$: Observable<boolean> = this._changesSubject$;

    constructor(svcm: Service.InjectedMembers, namespace: string, protected readonly _modelType: Model.Type<T>, private readonly _path: string) {
        this._service = new Service(svcm, namespace);
    }

    doesModelEntryExist(): Observable<boolean> {
        return this._service.exists<T>(this._modelType, this._path);
    }

    getModelEntry(projection?: ProjectionInformation): Observable<T> {
        return this._service.get<T>(this._modelType, this._path, projection);
    }

    updateModelEntry(model: T, projection?: ProjectionInformation): Observable<Response> {
        return this._service.update(model, this._path, projection).do(() => this._changesSubject$.next(true));
    }

    deleteModelEntry(): Observable<Response> {
        return this._service.delete(this._modelType, this._path).do(() => this._changesSubject$.next(true));
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/common/model.service.ts